// extracted by mini-css-extract-plugin
module.exports = {"SectionLegend":"PieLegend_SectionLegend__JrfBK","LegendRow":"PieLegend_LegendRow__gbmfx"};